module.exports = __webpack_public_path__ + "img/saurvi.9da8e436.jpeg";